import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import SiteAdminRoutes from './routes/SiteAdminRoutes';
import SuperAdminRoutes from './routes/SuperAdminRoutes';
import Login from './pages/Auth/Login';
import Unauthorized from './pages/Unauthorized';
import './styles/globals.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider, useAuth } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

function AppRoutes() {
  const { isLoggedIn, authInitialized, user } = useAuth();

  if (!authInitialized) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Helper function to get default route based on role
  const getDefaultRoute = () => {
    if (!user) return '/login';
    
    switch (user.role) {
      case 'super_admin':
        return '/super-admin/dashboard';
      case 'site_admin':
        return '/site-admin/dashboard';
      default:
        return '/';
    }
  };

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      
      {/* Default redirect */}
      <Route path="/" element={
        isLoggedIn ? <Navigate to={getDefaultRoute()} replace /> : <Navigate to="/login" replace />
      } />
      
      {/* Protected Routes */}
      {isLoggedIn ? (
        <>
          {/* Super Admin Routes - Only accessible by super_admin */}
          <Route path="/super-admin/*" element={
            user?.role === 'super_admin' ? 
              <SuperAdminRoutes /> : 
              <Navigate to="/unauthorized" replace />
          } />
          
          {/* Site Admin Routes - Only accessible by site_admin */}
          <Route path="/site-admin/*" element={
            user?.role === 'site_admin' ? 
              <SiteAdminRoutes /> : 
              <Navigate to="/unauthorized" replace />
          } />
          
          {/* Catch all other routes for logged-in users */}
          <Route path="*" element={<Navigate to={getDefaultRoute()} replace />} />
        </>
      ) : (
        /* Redirect all routes to login for non-authenticated users */
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  );
}

export default App;